import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import vehicleImg from '../../../assets/images/vehLocation.jpg'
import { Alert } from 'antd';
import Marquee from 'react-fast-marquee';

const VehiclePosition = ({ vehicle }) => {

  if (!vehicle?.latitude || !vehicle?.longitude) {
    return( 
        <Card className='text-center insp-card-body'>
            <CardHeader>
                <Alert
                    banner
                    message={
                    <Marquee pauseOnHover gradient={false}>
                      Les informations de géolocalisation de ce véhicule ne sont pas encore disponibles. Nous vous prions de bien vouloir réessayer plus tard.{" "}
                    </Marquee>
                    }
                />
            </CardHeader>
            <CardBody>
              <img src ={vehicleImg} />
            </CardBody>
        </Card>)
  }

  const lat = vehicle?.latitude
  const long = vehicle?.longitude

  const position = [lat, long];

  return (
    <div style={{ width: '100%', height: '400px' }}>
      <MapContainer center={position} zoom={13} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}>
          <Popup>
            Latitude: {lat} <br /> Longitude: {long}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
};

export default VehiclePosition;
